import React from 'react';
import pt from 'prop-types';
import { MrInputText } from '@ion/components';
import { CONSENT_ONETRUST_COOKIE_NAME } from 'app/components/analytics-builder/form-keys';
import { CONSENT_COOKIE_NAME } from 'app/components/analytics-builder/analytics-builder-settings';

export default function OneTrustConsentCookieName({ formState, setField, resetError }) {
  return (
    <MrInputText
      label="OneTrust Consent Cookie Name"
      onChange={setField}
      value={formState[CONSENT_ONETRUST_COOKIE_NAME]?.value ?? ''}
      onInput={resetError}
      name={CONSENT_ONETRUST_COOKIE_NAME}
      helperText={`Optional. Only if your site renames OneTrust's consent cookie (it must have the same contents as ${CONSENT_COOKIE_NAME}). Its saved choices apply when OneTrust is slow to load or blocked. Leave blank to use ${CONSENT_COOKIE_NAME}.`}
      placeholder={CONSENT_COOKIE_NAME}
      fullWidth
    />
  );
}

OneTrustConsentCookieName.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  resetError: pt.func.isRequired,
};
